import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['br', 'b', 'i', 'u', 'strong', 'em', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
        node.setAttribute('rel', 'noopener nofollow ugc');
        node.setAttribute('target', '_blank');

        const href = node.getAttribute('href') || '';
        if (/^\s*javascript:/i.test(href)) {
            node.removeAttribute('href');
        }
    }
});

export function sanitizeHtml(value) {
    if (value === null || value === undefined) return '';

    return DOMPurify.sanitize(String(value), {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOW_DATA_ATTR: false,
    });
}
